/* eslint-disable import/no-extraneous-dependencies */
// eslint-disable-next-line import/no-namespace
import * as __linariaCore from '../../../../../node_modules/@linaria/core';

// eslint-disable-next-line no-console
console.log(`>>>>>>>> linaria core`, __linariaCore);

const linaria =
  'default' in __linariaCore ? __linariaCore.default : __linariaCore;

export const css = (linaria as any).css;
export const cx = (linaria as any).cx;
